module.exports = __webpack_public_path__ + "img/front length from HPS to underbust.66bf034c.png";